import GameState from "slotworks/model/game-state";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import State from "slotworks/state-machine/states/state";
import Regulation from "slotworks/integration/revolver/regulations/regulation";

export default class RecoverSpin extends State {
    public onEnter() {
        Regulation.interactionStart();
        CommsManager.request(new SpinRequestPayload()).then(() => {
            GameState.getCurrentGame().getFirstRecord().beenPaid = true;
            GameState.getCurrentGame().latestRecord();

            this.complete();
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/states/recover-spin.ts